import emitter from '../utils/emitter'

export default {
  name: 'needs-slice',

  ui: {
    'inputs[]': '[js-needs-slice-input]',
  },

  events: [
    {
      on: 'click',
      target: 'inputs',
      handle (e) {
        emitter.trigger('openNeedsModal', { type: e.target.value })
      },
    },
  ],

  componentDidMount () {
  },
}
